import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FunctionalRoom } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class FunctionalRoomService extends InfrastructureService<FunctionalRoom> {
  protected readonly endpoint: string = '/FunctionalRooms';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
